import React from 'react';
import { FaClock, FaStar, FaUtensils } from 'react-icons/fa';
import './PostRecipe.css';
import './ResponsiveCardRecipe.css';

export const RecipePost = ({ recipe, title, src, alt, onClick }) => {
    // Support both prop formats
    const recipeData = recipe || {
        title: title,
        image: src,
        diet: 'Healthy Recipe',
        prepTime: '20 mins',
        rating: 4.8,
        cuisine: 'Community Recipe'
    };

    return (
       <div className="postWrapper" onClick={onClick} style={{ cursor: 'pointer' }}>
           <div className="leftInfo">
               <img src={recipeData.image || src} alt={alt || recipeData.title}/>
               {recipeData.diet && (
                   <span className="recipe-card-diet-badge">{recipeData.diet}</span>
               )}
               {recipeData.rating && (
                   <span className="recipe-card-rating-badge">
                       <FaStar className="star-icon" /> {recipeData.rating}
                   </span>
               )}
           </div>

           <div className="rigthInfo">
               <div className="recipe-card-meta-row">
                   {recipeData.prepTime && (
                       <span className="recipe-meta-item">
                           <FaClock className="meta-icon" /> {recipeData.prepTime}
                       </span>
                   )}
                   {recipeData.cuisine && (
                       <span className="recipe-meta-item">
                           <FaUtensils className="meta-icon" /> {recipeData.cuisine}
                       </span>
                   )}
               </div>

               <h2>{recipeData.title}</h2>

               {recipeData.description && (
                   <p className="recipe-card-desc">{recipeData.description}</p>
               )}

               <button 
                 type="button"
                 onClick={(e) => {
                   e.stopPropagation();
                   if (onClick) onClick();
                 }}
               >
                 See Recipe
               </button>
           </div>
       </div>
    );
};